<div class="backdrop">
  <div class="box flex h-screen w-screen flex-col items-center justify-center">
    <div>
      <!-- <div class="loader"></div> -->
      <div class="flex justify-center">
        <svg class="w-20" viewBox="0 0 464 602" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect class="logo-cyan" x="0" y="343" width="125" height="259" fill="#03829E" />
          <rect class="logo-magenta" x="169" y="0" width="125" height="602" fill="#CE2082" />
          <rect class="logo-yellow" x="339" y="0" width="125" height="181" fill="#F0BB11" />
        </svg>
      </div>
      <div class="text-lg mt-5">Accesso in corso...</div>
    </div>
  </div>
</div>
